export default {
  init() {
    // JavaScript to be fired on all pages

    /** GLOBAL VARIABLES */
    // var body = document.querySelector('body');
    /** END GLOBAL VARIABLES */

    // Homepage loading

    // 1. Load video 
        var $player = $("#bgndVideo");
        $player.YTPlayer();

    // 2. Once video is loading and playing, reveal overlaying image
        $player.on('YTPStart', function() {
            setTimeout(function(){
                $('.masthead__scroll').addClass('revealed');
            }, 500);
        });

    // 3. On scroll, add parallax to overlaying image
        // Do image parallax
        function imageParallax() {
            // Set variables
            var $window = $(window);
            // How far we've scrolled 
            var wScroll = $window.scrollTop();
            // Height of window
            var wHeight = $window.height();
            // Position of bottom of window
            var wScrollBottom = wScroll + wHeight;
            
            // Top parallax decor
            var $mainParallaxImage = $('.parallax-image--decor');

            // Process different parallax effects
            function processParallax(selector, speed) {
                selector.each(function () {
                    // position of element's top from top of window
                    var elTop = $(this).offset().top;
                    var change;
                    // If element is in window, change rate is based on scroll
                    if (elTop < wHeight) {
                        change = wScroll;
                        // If element is not in window view, change rate has offset 
                    } else {
                        change = (wScrollBottom - elTop);
                    }
                    // If element is in window do the parallax
                    if (wScrollBottom > elTop) {

                        $(this).css({
                            'transform': 'translateY(-' + change / speed + '%)',
                        });
                    }
                });
            }

            // Process parallax for each type of element
            processParallax($mainParallaxImage, 100);
        }

        // Only do this if it's not mobile
        if (window.innerWidth > 768) {
            // Do parallax effect
            $(window).scroll(imageParallax);
        }



    // Highlight active sub-nav item when matching section is scrolled to in viewport
        // Get section or article by href
        // function getRelatedContent(el){
        //     return $($(el).attr('href'));
        // }
        // Get link by section or article id
        // function getRelatedNavigation(el){
        //     return $(el).attr('id');
        //     // return $('.sub-nav__link[href=#'++']');
        // }

        // var wpDefaults={
        //     context    : window,
        //     continuous : true,
        //     enabled    : true,
        //     horizontal : false,
        //     offset     : 0,
        //     triggerOnce: false,
        // };

        // eslint-disable-next-line no-unused-vars
        $('.section').each(function(){
            var section = $(this).attr('id');
            var offset  = -$(this).height() + 250;

            $(this).waypoint(function(direction) {
                // Highlight element when related content
                // is 10% percent from the bottom... 
                // remove if below
                var matchingLink = $('.sub-nav__link[href=#'+section+']');
                matchingLink.toggleClass('sub-nav__link--active', direction === 'down');
            }, {
                continuous: true,
                offset: '50%', // 
            });
            
            $(this).waypoint(function(direction) {
                // Highlight element when bottom of related content
                // is 100px from the top - remove if less
                // TODO - make function for this
                var matchingLink = $('.sub-nav__link[href=#'+section+']');
                matchingLink.toggleClass('sub-nav__link--active', direction === 'up');
            }, {
                continuous: true,
                offset: offset,
            });
           
        });


    /** SKIP LINK NAVIGATION */
    $('#skip-to-content').click(function () {
      // strip the leading hash and declare
      // the content we're skipping to
      var skipTo = "#" + this.href.split('#')[1];
      // Setting 'tabindex' to -1 takes an element out of normal
      // tab flow but allows it to be focused via javascript
      $(skipTo).attr('tabindex', -1).on('blur focusout', function () {
        // when focus leaves this element, 
        // remove the tabindex attribute
        $(this).removeAttr('tabindex');
      }).focus(); // focus on the content container
    });
    /** END SKIP LINK NAVIGATION */
    
    /** MASTHEAD PRGRESSIVE IMAGES **/
    var masthead = document.querySelector('.masthead'),
    placeholderOverlay = document.querySelector('.masthead__overlay');

    if (masthead && placeholderOverlay) {
        // Load full size image. When loaded, fade our placeholder add it as bg to masthead
        var img = new Image();
        img.src = masthead.dataset.imageSrc;
        img.onload = function () {
            placeholderOverlay.classList.add('fade-out');
            masthead.style.backgroundImage = "url(" + img.src + ")";
        };
    }
    /** END MASTHEAD PRGRESSIVE IMAGES **/

    /** ANIMATED ANCHOR LINKS **/
    $('a[href*="#"]:not([href="#"])').click(function (e) {
        // Doesn't do it on page builder tabs
        if (!$(this).closest('li').hasClass('vc_tta-tab')) {
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                var target            = $(this.hash);
                var $this             = this;
                // var header            = $('header.header');
                // var wpAdminBar        = $('#wpadminbar');
                // var fixedHeaderOffset = parseInt(header.outerHeight()) - parseInt(header.css("padding-top").replace("px", ""));

                // If we're logged in and WP ADmin Bar exists, add it to the offset
                // if ( wpAdminBar.length ) {
                //     fixedHeaderOffset += parseInt(wpAdminBar.outerHeight());
                // }

                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                
                if (target.length) {
                    $('html,body').animate({
                        scrollTop: (target.offset().top),
                    }, 500, function () {
                        if (history.pushState) {
                            history.pushState(null, null, $this.hash);
                        }
                        else {
                            location.hash = $this.hash;
                        }
                    });
                    e.preventDefault();
                }
            }
        }    
    });
    /** END ANIMATED ANCHOR LINKS **/

    /** Break link text to new line when link text is a URL **/
    $(document).ready(function(){
        $('a').each(function() {
            var $this = $(this);
            var innerLink = $this.text();
            if (innerLink.startsWith('http')) {
                $this.css('word-break','break-all');
            }
        });
    });
    /** End Break link text to new line when link text is a URL **/

    // Slick
    $('.highlights').slick({
        autoplay      : false,
        infinite      : false,
        centerMode    : false,
        cssEase       : 'linear',
        slidesToShow  : 1,
        slidesToScroll: 1,
        swipeToSlide  : true,
        dots          : false,
        arrows        : true,
        fade          : false,
        mobileFirst   : true,
        responsive    : [
            {
                breakpoint: 568,
                settings  : {
                    slidesToShow  : 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1280,
                settings  : {
                    slidesToShow  : 3,
                    slidesToScroll: 1,
                },
            },
        ],
        prevArrow: '<button type="button" class="slick-prev"><span class="icon-arrow-left"></span><span class="screen-reader-text">Previous</span></button>',
        nextArrow: '<button type="button" class="slick-next"><span class="icon-arrow-right"></span><span class="screen-reader-text">Next</span></button>',
    });

    // Magnific popup
    $('.popup-modal').magnificPopup({
		type     : 'inline',
        midClick : true,
        mainClass: 'mfp-fade',
        removalDelay: 800,
    });
    
	$(document).on('click', '.popup-modal-dismiss', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
    });

    function itemReveal() {
        var itemQueue = [];
        var delay = 100;
        var queueTimer;

        function processItemQueue() {
            if (queueTimer) return // We're already processing the queue
            queueTimer = window.setInterval(function () {
                if (itemQueue.length) {
                    $(itemQueue.shift()).addClass('revealed');
                    processItemQueue()
                } else {
                    window.clearInterval(queueTimer)
                    queueTimer = null
                }
            }, delay)
        }

        $(".reveal").waypoint(function () {
            itemQueue.push(this.element)
            processItemQueue();
        }, {
            offset: '80%',
        });

        $(".animation-wrap").waypoint(function () {
            itemQueue.push(this.element)
            processItemQueue();
        }, {
            offset: '80%',
        });

        $('.parallax-image--decor').waypoint(function () {
            itemQueue.push(this.element)
            processItemQueue();
        }, {
            offset: '35%',
        });

        /* Sticky sub-nav */
        var nav = $('.sub-nav');
        var who = $('#who-we-are');
        var contact = $('#contact');

        if (window.innerWidth > 992) {

            who.waypoint({
                handler: function(direction) {
                    if (direction === 'down') { // trigger when first section is halfway up the page
                        nav.addClass('sub-nav--scrolled');
                    } else if (direction === 'up') {
                        nav.removeClass('sub-nav--scrolled');
                    }
                },
                offset: '35%', // percentage from top of window
            });

            contact.waypoint({
                handler: function(direction) {
                    if (direction === 'down') {
                        console.log(direction);
                        nav.removeClass('sub-nav--scrolled');
                    } else if (direction === 'up') {
                        console.log(direction);
                        nav.addClass('sub-nav--scrolled');
                    }
                },
                offset: '70%', // percentage from top of window
            });

        } else {
            nav.waypoint({
                handler: function(direction) {
                    if (direction === 'down') {
                        nav.addClass('sub-nav--scrolled');
                    } else if (direction === 'up') {
                        nav.removeClass('sub-nav--scrolled');
                    }
                },
                offset: 0, // percentage from top of window
            });
        }

    }

    itemReveal();

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js